/* template */
<template minapp="mpx" xlang="wxml"><div :style="[(bannerStyle.back)] | transRpxStyle" class="banner-container"><div class="left-area"><mpx-image :src="(bannerStyle.icon)" @tap="clickExtra" class="banner-icon"/><div class="coupon-area"><template v-for="(item, index) in (couponList)"><coupon :couponData="(item)"/></template></div></div><mpx-view @tap="clickExtra" class="right-area"><div class="right-text">{{ extraText }}</div></mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"ma3428162"}'>
  .banner-container
    height 34px
    padding 8px 15px 8px 8px
    border-radius 8px
    background #fff
    display flex
    align-items center
    justify-content space-between
    box-sizing border-box
    .left-area
      max-width calc(100% - 58px)
      display flex
      align-items center
      .coupon-area
        display flex
        overflow auto
        align-items center
      .banner-icon
        width 58px
        height 19px
        flex-shrink 0
        margin-right 8px
    .right-area
      flex-shrink 0
      line-height 0
      .right-text
        font-family PingFang SC
        font-size 12px
        font-weight 400
        line-height 12px
        color #FF4343
        position relative
        padding 9px 6px
        &::after
          content ''
          width 4px
          height 4px
          border-top 1.5px solid
          border-right 1.5px solid
          position absolute
          top 12px
          right 0
          transform rotate(45deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "ma3428162"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexa3428162%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexa3428162%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["ma3428162"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexa3428162/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'coupon':getComponent(require("./coupon.mpx?isComponent&outputPath=components%2Fcoupon17eb0cf7%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
